import { create } from 'zustand';

interface ExpressStore {
	expressData: any;
	setExpressData: (expressData: any) => void;
	draftExpressData: any;
	setDraftExpressData: (draftExpressData: any) => void;
	filteredDrafts: any;
	setFilteredDrafts: (filteredDrafts: any) => void;
}

export const useExpressStore = create<ExpressStore>((set) => ({
	expressData: null,
	setExpressData: (expressData: any) => set({ expressData }),
	draftExpressData: null,
	setDraftExpressData: (draftExpressData: any) => set({ draftExpressData }),
	filteredDrafts: null,
	setFilteredDrafts: (filteredDrafts: any) => set({ filteredDrafts }),
}));
